module.exports = __webpack_public_path__ + "img/mail_forward.1429e88a.svg";